module.exports = __webpack_public_path__ + "static/media/addUser.18231dcf.svg";